import { AbsolutePaths } from "constants/routes";
import { matchPath } from "react-router-dom";
import { PageNames } from "types-for/routes";

/**
 * Return the PageName item for the current route.
 * @param absolutePathname The actual absolute route path.
 * @returns The PageName item for the current route or null if no route has been found.
 */
export const getCurrentPage = (absolutePathname: string): PageNames | null => {
    return (
        (Object.keys(AbsolutePaths).find((key) =>
            matchPath(AbsolutePaths[key as PageNames](), absolutePathname)
        ) as PageNames) || null
    );
};
